import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=dfb17d9c&scoped=true&"
import script from "./SelectGame.vue?vue&type=script&lang=js&"
export * from "./SelectGame.vue?vue&type=script&lang=js&"
import style0 from "./SelectGame.vue?vue&type=style&index=0&id=dfb17d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb17d9c",
  null
  
)

export default component.exports